﻿const alertBarDismissSelector = "[data-alert-bar-dismiss]";
import Cookies from 'js-cookie'
export function initAlertBarDismiss() {
    let alertBars = document.querySelectorAll(alertBarDismissSelector);
    if (alertBars.length){
        alertBars.forEach(f=> {
           f.addEventListener("click", function (e){
               Cookies.set('alert-bar-update', f.dataset.alertBarDismiss , { expires: 365, path: '' })
               f.closest(".alert-bar").remove();
           });
        });
    }
}
